import { tkHost } from '@settings';
import { CtaButton } from '@tkww/orion-web-ds-action';
import { Illustration } from '@tkww/orion-web-ds-graphic';
import { TextBody, TextHero } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './styles.scss';

export const NoMoreResults: React.FC = () => {
	const handleExploreMore = () => {
		window.location.href = `${tkHost}/marketplace`;
	};
	return (
		<div className={Styles.noMoreResultsWrapper}>
			<Illustration
				name="book-vendor-1"
				aria-label="No more results illustration"
				className={Styles.icon}
			/>
			<TextHero size="sm">All clear!</TextHero>
			<TextBody size="lg">
				You reached out to all the vendors who’ve worked with your venue.
			</TextBody>
			<CtaButton
				size="lg"
				styleType="primary"
				onClick={handleExploreMore}
				data-testid="explore-more-vendors-button"
			>
				Explore more vendors
			</CtaButton>
		</div>
	);
};
